import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { trackEvent, EVENTS } from "@/lib/analytics";

const Faq = ({ items }) => (
  <Accordion
    type="single"
    collapsible
    data-testid="pricing-faq-accordion"
    className="mx-auto max-w-3xl"
    onValueChange={(v) => v && trackEvent(EVENTS.pricingFaqOpened, { item: v })}
  >
    {items.map((item, i) => (
      <AccordionItem key={i} value={`faq-${i}`} className="border-coacher-border">
        <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-display text-base sm:text-lg font-semibold uppercase tracking-wide text-coacher-navy hover:text-coacher-red hover:no-underline">
          {item.q}
        </AccordionTrigger>
        <AccordionContent data-testid={`faq-content-${i}`} className="text-sm sm:text-base leading-relaxed text-coacher-slate">
          {item.a}
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);

export default Faq;
